import { render, staticRenderFns } from "./AgentTransactionDetail.vue?vue&type=template&id=f2a7f36e&scoped=true"
import script from "./AgentTransactionDetail.vue?vue&type=script&lang=js"
export * from "./AgentTransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./AgentTransactionDetail.vue?vue&type=style&index=0&id=f2a7f36e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a7f36e",
  null
  
)

export default component.exports